<template>
  <div>
    <div id="app">
      <keep-alive>
        <router-view v-if="isRouterAlive" />
      </keep-alive>
      <el-backtop :bottom="100"> </el-backtop>
    </div>
  </div>
</template>
<script>
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  watch: {},
  mounted() {},
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="less">
* {
  font-family: 'Microsoft YaHei';
}
html,
body {
  width: 100%;
  margin: 0;
  padding: 0;
  min-width: 1200px;
}
</style>
